import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IApiClientAuthorization } from '~/lib/api/ApiClient';
import type { IApiLogInAsRequestBody } from '../AuthApi.types';
import { useApi } from '~/lib/api/useApi';
import { useAuth } from '~/lib/auth';

export type IUseLogInAsMutationValues = {
  body: IApiLogInAsRequestBody;
};

export const useLogInAsMutation = (): UseMutationResult<
  IApiClientAuthorization,
  unknown,
  IUseLogInAsMutationValues
> => {
  const auth = useAuth();
  const api = useApi();
  const appRegion = api.getAuthorization()?.region;

  return useMutation({
    mutationFn: appRegion
      ? (values: IUseLogInAsMutationValues) =>
          auth.logInAs(appRegion, values.body)
      : undefined,
  });
};
